import type { SVGProps } from 'react'
const SvgSyTechSolidFilestore = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fill="#e9e9e9" d="M8 12h8l-2 2h-4z" />
		<path fillOpacity={0.24} d="M7 4h10l1 2H6zM4 7h16l1 2H3z" />
		<path d="M22 20v-9h-6l-2 3h-4l-2-3H2v9z" />
	</svg>
)
export default SvgSyTechSolidFilestore
